import type { argusAuthPlugin } from '@argus-labs/auth-backend/src/auth-plugin'
import { legacyAuthClientPlugin } from '@argus-labs/auth-shared/better-auth-plugin/client-plugin'
import type { BetterAuthClientPlugin } from 'better-auth/client'
import { anonymousClient, emailOTPClient, oneTimeTokenClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'
import { API_URL } from '@/env'

export const authClient = createAuthClient({
  baseURL: API_URL,
  basePath: '/auth',
  plugins: [
    anonymousClient(),
    emailOTPClient(),
    oneTimeTokenClient(),
    {
      id: 'argus-auth',
      $InferServerPlugin: {} as ReturnType<typeof argusAuthPlugin>,
    } satisfies BetterAuthClientPlugin,
    legacyAuthClientPlugin(),
  ],
})
